export default {
  series: 2,
  data: 'A;B;C\na;0;100\nb;100;200\nc;20;50\nd;30;50',
  assignDataFields: [
    {
      labels: 'A',
      low: 'B',
      high: 'C',
    },
    {
      labels: 'A',
      values: 'B',
    },
  ],
  seriesMapping: [
    {
      x: 0,
      low: 1,
      high: 2,
    },
    {
      x: 0,
      y: 1,
    },
  ],
};
